import { defineStore } from 'pinia'

export const useContentStore = defineStore("'content-store'", {
  state: () => ({
    loading: true,
  }),
})
